import React, { useState, useEffect, useCallback } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiButton, EuiText, EuiTabbedContent } from '@elastic/eui';
import UserTablelist from './userTableList';
import UserAccessPermissions from './userAccessPermission';
import { EuiLoadingContent } from '@elastic/eui';
import { useSelector } from 'react-redux';
import AddUserFlyout from './addUserFlyout';
import UserOutletPermission from './userOutletPermission';
import API from '../../api/axios/API';
import { userHasPermission } from '../../helper/auth';
import './style.css';

const flyoutCallback = (setIsFlyoutVisible) => {
    setIsFlyoutVisible(true);
};

const selectedUserCallback = (value, setSelectedUser) => {
    setSelectedUser(value);
};

const permissionUpdateCallback = (value, setPermissionUpdate) => {
    setPermissionUpdate(value);
};

const accessPermissionCallback = (value, setAccessPermissionState) => {
    setAccessPermissionState(value);
};

export const UserComponent = (prpos) => {
    const [isFlyoutVisible, setIsFlyoutVisible] = useState(false);
    const [selectedUserId, setSelectedUser] = useState(1);
    const permissions = useSelector((state) => state.permission.permission);
    const [accessPermissionState, setAccessPermissionState] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [useSideEffect, setUseSideEffect] = useState({});

    const setSelectedUserCallback = useCallback((value) => {
        selectedUserCallback(value, setSelectedUser);
    }, []);

    const openFlyoutCallback = useCallback(() => {
        flyoutCallback(setIsFlyoutVisible);
    }, []);

    const setPermissionUpdateCallback = useCallback((value) => {
        permissionUpdateCallback(value, setPermissionUpdate);
    }, []);

    const setAccessPermissionStateCallback = useCallback((value) => {
        accessPermissionCallback(value, setAccessPermissionState);
    }, []);

    const [usersList, setUsersList] = useState({
        isLoading: true,
        error: null,
        users: undefined,
    });

    const [userPermissions, setUserPeermissions] = useState({
        isLoading: true,
        error: null,
        userPermissions: undefined,
    });

    const fetchUsersList = async () => {
        let response;
        try {
            response = await API.get(`restaurants/:restaurantId/users`);
        } catch (error) {
            response = error;
        }

        if (response.success) {
            response = {
                ...usersList,
                isLoading: false,
                users: response,
            };
        } else {
            response = {
                ...usersList,
                isLoading: false,
                error: true,
            };
        }
        setUsersList(response);
    };
    const [permissionUpdate, setPermissionUpdate] = useState(false);
    const fetchUserPermissions = async () => {
        let response;
        try {
            response = await API.get(`restaurants/:restaurantId/users/permissions`);
        } catch (error) {
            response = error;
        }

        if (response.success) {
            response = {
                ...usersList,
                isLoading: false,
                userPermissions: response,
            };
        } else {
            response = {
                ...usersList,
                isLoading: false,
                error: true,
            };
        }
        setUserPeermissions(response);
    };

    useEffect(() => {
        fetchUsersList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionUpdate]);

    useEffect(() => {
        fetchUserPermissions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let allPermission = [];
    if (usersList.isLoading || userPermissions.isLoading) return <EuiLoadingContent lines={10} />;
    if (usersList.error || userPermissions.error) return 'error...';
    let filteredUser = usersList.users;

    if (selectedUserId) {
        filteredUser = usersList.users.users.filter((user) => user.user.id === selectedUserId)[0]; // seleted user = 1
        if (!filteredUser) {
            filteredUser = usersList.users.users[0];
            setSelectedUser(usersList.users.users[0].user.id);
        }
    }
    let flyout;

    if (isFlyoutVisible) {
        flyout = <AddUserFlyout setIsFlyoutVisible={setIsFlyoutVisible} setPermissionUpdate={setPermissionUpdate} />;
    }
    allPermission = userPermissions.userPermissions;
    const onTabClick = (selectedTab) => {
        setSelectedTab(selectedTab.index);
    };

    const tabs = [
        {
            index: 0,
            id: 'Outlet Permission',
            name: 'Outlet Permission',
            content: filteredUser && (
                <UserOutletPermission
                    setUseSideEffect={setUseSideEffect}
                    useSideEffect={useSideEffect}
                    user={filteredUser}
                />
            ),
        },
        {
            index: 1,
            id: 'Access Permission',
            name: 'Access Permission',
            content: filteredUser && (
                <UserAccessPermissions
                    user={filteredUser}
                    modules={allPermission}
                    selectedUser={selectedUserId}
                    state={accessPermissionState}
                    stateChange={setAccessPermissionStateCallback}
                    setPermissionUpdate={setPermissionUpdateCallback}
                />
            ),
        },
    ];

    return (
        <EuiFlexGroup className='user-main'>
            <EuiFlexItem>
                <EuiText>
                    <EuiFlexGroup>
                        <EuiFlexItem grow={3}>
                            <h3>Users</h3>
                        </EuiFlexItem>
                        <EuiFlexItem>
                            {userHasPermission(permissions, '/users', 'write') && (
                                <EuiButton onClick={() => setIsFlyoutVisible(true)}>Add user</EuiButton>
                            )}
                            {flyout}
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiText>
                <UserTablelist
                    users={usersList.users}
                    selectedUser={selectedUserId}
                    setSelectedUser={setSelectedUserCallback}
                    openFlyOut={openFlyoutCallback}
                    setPermissionUpdate={setPermissionUpdateCallback}
                    setUseSideEffect={setUseSideEffect}
                />
            </EuiFlexItem>
            <EuiFlexItem>
                <div style={{ marginBottom: 30 }}>
                    <EuiText>
                        <h3>Access and Permissions Outlet</h3>
                    </EuiText>
                </div>
                <EuiTabbedContent tabs={tabs} selectedTab={tabs[selectedTab]} onTabClick={onTabClick} />
            </EuiFlexItem>
        </EuiFlexGroup>
    );
};
